var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.buttonClass,attrs:{"tabindex":"0"}},[_c('IneaIcone',{attrs:{"name":_vm.iconName,"color":_vm.iconColor,"comment":_vm.comment,"size":"sm","role":"button","aria-expanded":"false"}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }